export default __webpack_public_path__ + "7884bfdc39312d2ba1002d258b6cffd3.svg";